/* eslint-disable camelcase */
import { API } from "./API";

export const getK3Tasks = (query) => {
  var {
    id,
    taskId,
    taskIds,
    keyword,
    sort_by,
    sort_order,
    type,
    status,
    src_agent_id,
    target_agent_id,
    page = 1,
    limit = 12
  } = query;

  var queryStr = '';

  if (sort_by) {
    queryStr += `sort_by=${sort_by}`;
    if (sort_order) {
      queryStr += `&sort_order=${sort_order}`;
    }
  }

  if (id)
    queryStr += `&id=${id}`;

  if (taskId)
    queryStr += `&task_id=${taskId}`;

  if (taskIds)
    queryStr += `&task_ids=${taskIds}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  if (type)
    queryStr += `&type=${type}`;

  if (status)
    queryStr += `&status=${status}`;

  if (src_agent_id)
    queryStr += `&src_agent_id=${src_agent_id}`;

  if (target_agent_id)
    queryStr += `&target_agent_id=${target_agent_id}`;

  if (page)
    queryStr += `&page=${page}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/k3task?${queryStr}`);
}

export const setK3Tasks = (tasks, query = {}) => {
  return API.post(`${process.env.REACT_APP_API_URL}/api/k3task`, tasks);
}

export const getK3TaskLogs = (query) => {
  var { task_id, from_time } = query;
  var queryStr = `task_id=${task_id}`;

  if (from_time)
    queryStr += `&from_time=${from_time}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/log?${queryStr}`);
}

export const k3taskService = {
  getK3Tasks,
  setK3Tasks,
  getK3TaskLogs
} 